(function () {
  if (!document.body || !document.body.classList.contains("template-index")) {
    return;
  }

  var selectors = [
    ".slideshow__text-content",
    "[class*='customstyleservice_kfjpy3'] .service",
    "[class*='customstyleservice_kfjpy3'] .service-item",
    ".section-title-1",
    "[class*='ai_gen_block_2ff2e7f']",
    ".jdgm-carousel-wrapper",
    ".tp-widget",
    "[class*='gift_concierge']"
  ];

  var nodes = Array.prototype.slice.call(document.querySelectorAll(selectors.join(",")));

  nodes.forEach(function (node, index) {
    node.classList.add("ens-premium-reveal");
    if (index % 3 === 0) {
      node.classList.add("ens-premium-reveal--left");
    } else if (index % 3 === 1) {
      node.classList.add("ens-premium-reveal--right");
    } else {
      node.classList.add("ens-premium-reveal--up");
    }
  });

  if (!("IntersectionObserver" in window)) {
    nodes.forEach(function (node) {
      node.classList.add("is-visible");
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.14, rootMargin: "0px 0px -6% 0px" }
  );

  nodes.forEach(function (node, index) {
    node.style.transitionDelay = Math.min(index % 4, 3) * 70 + "ms";
    observer.observe(node);
  });
})();
